<template>
	<div id="Bigcoffeegatheringdetails" class="centert">
		<div style="position: fixed;bottom: 5px;right: 50px;width: 50px;height: 50px;background-color: red;color: #FFF;z-index: 2;line-height: 50px;text-align: center;" @click="fha">
				  返回
		</div>
		<!-- 头标签 -->
		<dpubtop></dpubtop>
		<!-- 中间 -->
		<div class="Bigcoffdetails">
			<!-- 头部 -->
			<div class="pub_pub">
				<div class="pub_title">
					<div class="img_logo">
						<img src="../../../imges/lebiao/qzzp.png" alt="">
					</div>
					<div class="title_t">
						<div class="imhg_ti">
							<img src="../../../imges/lebiao/qzzp_font.png" alt="">
						</div>
						<div class="sm_t">
							<div style="float:left"><span>企业</span><span style="color:#D7230C;">VR</span></div>
						</div>
					</div>
				</div>
				<div style="width: 0px;height: 36px;border: 1px solid #ececec;float: left;">
					<!-- 中间线 -->
				</div>
				<div class="ckgd_dh">
					<div class="sy">
						<div class="sy_img">
							<img src="../../../imges/details/sy.png" alt="">
						</div>
						<router-link class="sy_title" to="/" style="text-decoration: none;
							">首页</router-link>
					</div>
					<div class="jt" style="margin-top: 0px;">
						<img src="../../../imges/details/jt.png" alt="">
					</div>
					<div class="name">企业VR</div>
				</div>
				<div style="width: 200px;height: 50px;float: right;">
					<router-link to="/login" tag="div" style="width: 60px;height: 30px;background: #ff5a44;text-align: center;line-height: 30px;color: #FFF;border-radius: 5px;float: left;
						">登录</router-link>
					<router-link to="/register" tag="div" style="width: 60px;height: 30px;background: #ff5a44;text-align: center;line-height: 30px;color: #FFF;border-radius: 5px;float: left;margin-left: 10px;
							">注册</router-link>
				</div>
			</div>
			<div class="pub_lb_s">
				<img src="../../../imges/hzhb1.png" style="width:100%" alt="" @click="new_zzcxs(142)" />
			</div>
			
			<div id="Expertthinkatnk" style="width: 100%;height: 400px;">
				<el-carousel style="box-shadow: 0 4px 24px rgba(0,0,0,.16);margin-top: 10px;" :interval="5000" arrow="none">
					<el-carousel-item v-for="(item,index) in 1" :key="index">
						<div class="z_warp">
							<router-link tag="div" :to="{ path:'/zjzkdetail',query:{id:o.id,title:o.title} }"  class="lb_cont" v-for="(o,index) in xptjlist[index]" :key="index">
								<div class="list_lb_img">
									<img v-lazy="o.picture" alt="">
								</div>
								<div class="xp_title" style="text-align: center;">
									 {{o.title}}&nbsp;&nbsp;{{o.position}}
								</div>
								<div tag="div" class="ckxq_xp"
									>
									查看详情
								</div>
							</router-link>
						</div>
					</el-carousel-item>
				</el-carousel>
			</div>
			
			<!-- 头部结束 -->
			<div class="top_bottom">
				<div style="width: 100%;height: 100px;">
					<div class="maptop_b">
						行业筛选：
						<el-cascader style="width: 150px;" placeholder="搜索：行业" class="eloptionxg" :options="industry"
							@change="handleAreaChange" filterable>
						</el-cascader>
					</div>
					<div class="maptop_b">
						地区筛选：
						<el-cascader style="width: 150px;" placeholder="搜索：行业" class="eloptionxg" :options="cityoptions"
							@change="handleAreaarea" filterable>
						</el-cascader>
					</div>
					<div class="maptop_a" style="margin-top: 4px !important;">
						精确搜索:
						<div class="maptop_a_a">
							<input v-model="keyword" type="text" placeholder="请输入内容">
							<div @click="selectChild1">
								搜索
							</div>
						</div>
					</div>
				</div>
				<div style="width: 100%;height: 1000px;">
					<div @click="GFWZ(item.vrlink)" class="Vrshowtop" style="position: relative;border: 1px dotted"
						v-for="(item,index) in qyLIST" :key="index">
						<div style="width: 100%;height: 100px;">
							<img v-lazy="item.logo" alt="" style="width: 100%;height: 100%;">
						</div>
						<div style="width: 100%;height: 25px;white-space:nowrap;
overflow:hidden;
text-overflow:ellipsis;font-size: 12px;line-height: 25px;">
							主营：{{item.mainsell}}
						</div>
						<div
							style="width: 100%;height: 30px;position: absolute;bottom: 0px;background: #ececec;opacity: 0.6;color: #000;text-align: center;line-height: 30px;">
							{{item.title}}
						</div>
					</div>
				</div>
				<!--  -->
				<div style="width: 100%;height: 70px;margin-top: 50px;text-align: center;">
					<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
						:current-page.sync="currentPage" :page-size="pageSize" layout="total, prev, pager, next"
						:total="Totals">
					</el-pagination>
				</div>
			</div>
			<!-- 广告1 -->
			<div class="advertisementone">
				<advertisementone></advertisementone>
			</div>
		</div>
		<!-- 中间结束 -->
		<!-- 尾标签 -->
		<myfooter></myfooter>
	</div>
</template>

<script>
	import http from "@/utils/http";
	import cityoptions from '../../../utils/city.js'
	export default {
		data() {
			return {
				options: [],
				searchData: {
					type: '职位',
					keyword: '' //搜索框查询关键字
				},
				xptjlist:'',
				value: '',
				names: this.$route.query.name,
				title: this.$route.query.title,
				keyword: '',
				industry: [],
				cityoptions: [],
				qyLIST: '',
				currentPage: 1, //当前页
				pageSize: 24, //当前每页数据
				Totals: 1, //总数据条数
				hya: '',
				diqua: '',
			}
		},
		methods: {
			fha(){
				console.log('返回上一层')
				this.$router.go(-1);//返回上一层
			},
			async selectChild1() {
				let self = this
				let newList = []
				if (this.keyword != '') {
					let res = await http.post('api/picture/vr_index', {
						model: 'qydb',
						type: 'content',
						mid: '4',
						rows_limit: '24',
						// vr_status: '2',
						title: this.keyword
					})
					let selt = this
					this.Totals = res.data.data.list.total
					this.qyLIST = res.data.data.list.data
					this.currentPage = 1
				} else {
					alert('请输入内容！')
				}
			},
			GFWZ(o) {
				window.open(o)
			},
			// 分页
			handleSizeChange(val) {
				console.log(`每页 ${val} 条`);
			},
			async handleCurrentChange(val) {
				let res = await http.post('api/picture/vr_index', {
					model: 'qydb',
					type: 'content',
					mid: '4',
					fid: this.hya,
					area: this.diqua,
					// vr_status: '2',
					rows_limit: '24',
					page: val,
					title: this.keyword
				})
				this.qyLIST = res.data.data.list.data
				this.Totals = res.data.data.count
			},
			async handleAreaChange(val) {
				let that = this
				that.hya = val[1]
				let newList = []
				let res = await http.post('api/picture/vr_index', {
					model: 'qydb',
					type: 'content',
					mid: '4',
					fid: that.hya,
					area: that.diqua,
					// vr_status: '2',
					rows_limit: '24'
				})
				this.Totals = res.data.data.list.total
				this.qyLIST = res.data.data.list.data
				this.currentPage = 1
				console.log(res)
			},
			async handleAreaarea(val) {
				let that = this
				that.diqua = val[0]
				let newList = []
				let res = await http.post('api/common/index', {
					model: 'qydb',
					type: 'content',
					mid: '4',
					fid: this.hya,
					area: this.diqua,
					rows_limit: '24'
				})
				this.Totals = res.data.data.list.total
				res.data.data.list.data.forEach((item, index) => {
					if (item.posix == '' || item.posiy == '' || item.posix == null || item.posiy ==
						null) {} else {
						item.visible = false
						item.events = {
							click() {
								that.Ce.extData.xxct = ''
								that.window = this.Ce.extData
								that.$nextTick(() => {
									that.window.visible = true;
								});
							}
						}
						newList.push(item)
					}
				})
				that.qyLIST = newList
			},
		},
		async mounted() {
			let res2 = await http.get('index.php/bscard/wxapp.Sorts')
			this.options = res2.data.data


			this.cityoptions = cityoptions
			let res = await http.get('api/qydb/index')
			let batchdata = res.data.data
			let dataValueBatch = batchdata => batchdata.map(({
				id,
				name,
				child_1
			}) => (child_1 ? {
				value: id,
				label: name,
				children: dataValueBatch(child_1)
			} : {
				value: id,
				label: name
			}))
			this.industry = dataValueBatch(batchdata)

			let res3 = await http.post('api/picture/vr_index', {
				model: 'qydb',
				type: 'content',
				mid: '4',
				// vr_status: '2',
				rows_limit: '24'
			})
			console.log(res3)
			this.qyLIST = res3.data.data.list.data
			this.Totals = res3.data.data.list.total
			this.currentPage = res3.data.data.list.current_page
			
			
			let res4 = await http.post('api/Common/index', {
				model: 'expert',
				type: 'content',
				mid: '6',
				rows_limit: '5'
			})
			let xpList = res4.data.data.list.data
			let newArr = [
				[],
				[],
			]
			xpList.forEach((item, index) => {
				if (index < 4) {
					newArr[0].push(item)
				} else if (index >= 4 && index < 8) {
					newArr[1].push(item)
				} else if (index >= 8 && index < 12) {
					newArr[2].push(item)
				}
			})
			this.xptjlist = newArr
		},
		components: {
			// 尾标签,
			myfooter: resolve => require(['@/components/myfooter'], resolve),
			// 头标签
			dpubtop: resolve => require(['@/components/dpubtop/dpubtop'], resolve),
			//广告
			advertisementone: resolve => require(['@/components/advertisementone'], resolve),
		}
	}
</script>

<style scoped>
	.centert {
		width: 1200px;
		margin: 0 auto;
	}

	.Bigcoffdetails {
		height: 2200px;
		width: 100%;
	}

	.pub_pub {
		margin-top: 20px;
		border-radius: 0px !important;
		height: 36px;
	}

	.pub_title {
		width: 350px;
		float: left;
	}

	.ctu_::after,
	.pub_title::after {
		content: '';
		display: block;
		clear: both;
	}

	.pub_title>img {
		width: 100%;
		height: 100%;
	}

	.img_logo {
		float: left;
		width: 36px;
		height: 36px;
		overflow: hidden;
	}

	.title_t {
		float: left;
		height: 36px;
		margin-left: 12px;
		font-weight: 600;
		letter-spacing: 3px;
	}

	.imhg_ti {
		height: 12px;
		width: 120px;
		margin-top: -5px;
	}

	.imhg_ti>img {
		width: 100%;
		height: 100%;
	}
	
	.advertisementone {
		width: 100%;
		height: 125px;
		margin-top: 20px;
	}

	.sm_t {
		height: 26px;
		line-height: 26px;
		font-size: 18px;
		margin-top: 8px;
	}

	.sm_pub {
		float: left;
		margin-left: 12px;
		font-size: 12px;
		color: #5e5d5d;
		cursor: pointer;
	}

	.sy::after,
	.ckgd_dh::after {
		content: '';
		display: block;
		clear: both;
	}

	.ckgd_dh {
		float: left;
		font-size: 12px;
		margin-left: 50px;
	}

	.ckgd_dh>div {
		float: left;
		height: 40px;
		line-height: 42px;
		color: #5e5d5d;
	}


	.name {
		line-height: 43px;
	}

	.sy_img {
		float: left;
		width: 20px;
		height: 20px;
	}

	.sy_img>img {
		margin-top: 13px;
		width: 100%;
		height: 100%;
	}

	.jt>img {
		margin-top: 10px;
	}

	.sy_title {
		float: left;
		height: 40px;
		line-height: 44px;
		margin-left: 6px;
		color: #5e5d5d;
	}

	.jt {
		width: 12px;
		height: 20px;
		margin-left: 6px;
		margin-right: 6px;
	}


	/* 头部结束 */
	.top_bottom {
		width: 100%;
		height: 1250px;
		box-shadow: #6e6e6e 0px 0px 10px;
		margin-top: 30px;
	}

	.top_bottom_T {
		width: 80%;
		height: 1150px;
		float: left;
	}

	.top_bottom_B {
		width: 20%;
		height: 1150px;
		float: left;
	}

	.dtiail_warp {
		width: 95%;
		margin: 0 auto;
	}

	.dtiail_title {
		margin-top: 40px;
		margin-bottom: 16px;
		text-align: center;
		font-size: 22px;
		color: #c00e0e;
	}

	.cont_dtiail>>>p>>>img {
		width: auto;
		height: 100%;
	}

	.cont_dtiail {
		overflow: hidden;
		margin-top: 20px;
		min-height: 300px;
	}

	.pub_lb_s {
		box-shadow: 0px 4px 24px rgba(0, 0, 0, 0.16);
		padding: 10px;
		width: 99.5%;
		margin: 20px auto;
	}

	.maptop_a {
		width: 30%;
		height: 50px;
		float: left;
		line-height: 80px;
		font-size: 20px;
		font-weight: 800;
		margin-left: 20px;
	}

	.maptop_a_a {
		width: 70%;
		margin-top: 25px;
		height: 40px;
		float: right;
		box-sizing: border-box;
		border: 3px solid #D7230C;
		background-color: #D7230C;
	}

	.maptop_a_a>input {
		width: 75%;
		height: 32px;
		float: left;
		border: 0px;
		outline: none;
	}

	.maptop_a_a>div {
		width: 20%;
		height: 32px;
		float: left;
		line-height: 32px;
		text-align: center;
		color: #fff;
		cursor: pointer;
	}

	.maptop_b {
		width: 300px;
		height: 50px;
		line-height: 50px;
		margin-top: 25px;
		margin-left: 10px;
		float: left;
		font-weight: 800;
		font-size: 20px;
	}

	.maptop_c {
		width: 120px;
		height: 50px;
		line-height: 50px;
		text-align: center;
		background-color: #D7230C;
		margin-left: 10px;
		margin-top: 25px;
		float: left;
		box-sizing: border-box;
		font-size: 20px;
		color: #FFF;
		font-weight: 800;
	}

	.Vrshowtop {
		width: 24%;
		height: 155px;
		float: left;
		margin-left: 0.8%;
		margin-top: 10px;
	}

	.Vrshowtop:hover {
		box-shadow: 0 10px 20px #888;
	}
	
	
	#Expertthinkatnk .z_warp::after {
		content: '';
		display: block;
		clear: both;
	}
	
	#Expertthinkatnk .lb_cont {
		float: left;
		width: calc((100% - 120px)/4);
		margin-left: 24px;
		height: 330px;
		border: 1px solid #ececec;
	}
	
	#Expertthinkatnk .list_lb_img {
		height: 250px;
	}
	
	#Expertthinkatnk .list_lb_img>img {
		width: 100%;
		height: 100%;
	}
	
	#Expertthinkatnk .xp_title {
		margin-left: 8px;
		font-size: 16px;
		font-weight: 600;
		margin-top: 12px;
		margin-bottom: 8px;
		white-space: nowrap;
		text-overflow: ellipsis;
		overflow: hidden;
		word-break: break-all;
	}
	
	#Expertthinkatnk  .ckxq_xp {
		width: 80px;
		border: 1px solid #ff4400;
		color: #ff4400;
		text-align: center;
		padding: 2px 0px;
		margin: 10px auto;
		cursor: pointer;
	}
	
	#Expertthinkatnk /deep/.el-carousel__container {
		height: 350px;
		margin-top: 20px;
	}
</style>
